/** Chrome 应用商店 · IPE 采集工具（已上架） */
export const IPE_PLUGIN_CHROME_STORE_URL =
  process.env.REACT_APP_IPE_PLUGIN_CHROME_STORE_URL
  || 'https://chromewebstore.google.com/detail/ipe%E9%87%87%E9%9B%86%E5%B7%A5%E5%85%B7/ajlohndkojofcoaeofeajbagipipldbb?hl=zh-CN&utm_source=ipe_workbench';

/** 全局悬浮球：客服 / 教程 / 工具栏 配置（可通过 REACT_APP_* 环境变量覆盖） */
export const IPE_SUPPORT_CONFIG = {
  wechatQrcodeSrc: process.env.REACT_APP_IPE_WECHAT_QRCODE || '/weixin.jpg',
  defaultPhone: process.env.REACT_APP_IPE_SUPPORT_PHONE || '17302126743',
  tutorialUrl: process.env.REACT_APP_IPE_TUTORIAL_URL || '',
  /** 已上架时优先跳转 Chrome 应用商店；保留 zip 下载地址作兜底 */
  pluginDownloadUrl: process.env.REACT_APP_IPE_PLUGIN_DOWNLOAD_URL || '',
  pluginChromeStoreUrl: IPE_PLUGIN_CHROME_STORE_URL,
  feedbackEmail: process.env.REACT_APP_IPE_FEEDBACK_EMAIL || '',
};

/** 插件安装跳转地址：优先 Chrome 应用商店，其次 zip 包（不区分浏览器；页面内请用 resolvePluginStoreTarget） */
export function resolvePluginInstallUrl() {
  return IPE_SUPPORT_CONFIG.pluginChromeStoreUrl || IPE_SUPPORT_CONFIG.pluginDownloadUrl || '';
}
